import { render, staticRenderFns } from "./ToolsApiPage.vue?vue&type=template&id=1879b8f7&scoped=true&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1879b8f7",
  null
  
)

export default component.exports